import React from 'react'

import TimelineWrapper from '../TimelineWrapper'
import GroupWrapperV2 from '../GroupWrapperV2'
import MessageSkeletonV2 from '../../../../molecules/MessageSkeletonV2'

const TimelineSkeleton = () => {
  return (
    <TimelineWrapper start end>
      <GroupWrapperV2 start>
        <MessageSkeletonV2 />
      </GroupWrapperV2>

      <GroupWrapperV2>
        <MessageSkeletonV2 isYours />
      </GroupWrapperV2>
      <GroupWrapperV2 end />
    </TimelineWrapper>
  )
}

export default React.memo(TimelineSkeleton)
